export default __webpack_public_path__ + "c74889e7e04395e624477173439f58ee.png";